import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

var mutation = gql`
  mutation createFormTemplateVersion($organizationId: UUID!, $templateId:  UUID!, $content: String!) {
    createFormTemplateVersion(organizationId: $organizationId, templateId: $templateId, content: $content) {
      version
    }
  }  
`;


export function apiCreateFormTemplateVersion(organizationId, templateId, content) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");        
        client
            .mutate({
                mutation: mutation,
                variables: {organizationId, templateId, content},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.createFormTemplateVersion);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to create template revision");
                reject(err); // R
            })
    });
}


